// import NewOfferingButton, {EditOfferingButton, DeleteOfferingButton} from 'components/NewOfferingButton';
import NewCouponButton, {EditCouponButton, DeleteCouponButton} from 'components/coupons/NewCouponButton';
import React, { useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import ReactTable from 'react-table';
import { Route, Switch, useLocation, useHistory } from "util/router.js";
import {loadCoupons} from 'store/actions/couponActions'
import {loadOfferings} from 'store/actions/offeringsActions'
import {Helmet} from 'react-helmet'
import ShareButton from 'components/ShareButton'
import OfferingSection from 'components/OfferingSection';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import Section from 'components/Section'
import moment from 'moment-timezone'
import BackButton from 'components/BackButton';
import { apiRequest } from 'util/api/util';
import UserButton from 'components/CustomButtons/UserButton'
import { useAuth } from "util/auth.js";

const BASE_URL = process.env.REACT_APP_BOOKING_SUCCESS_URL

function RedemptionsTable(props) {

  const {couponId} = props
  const auth = useAuth();

  const location = useLocation();

  const [response, setResponse] = React.useState(null)
  const [redemptions, setRedemptions] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)

  useEffect(() => {

    if (!auth.user) {
      return
    }
    setIsLoading(true)

    apiRequest('app/coupons/getRedemptions', "POST", {
      couponId: couponId
    })
    .then(response => {
      
      if (response?.redemptions) {
        setRedemptions(response?.redemptions)
        console.log(response.redemptions)
      }
      setIsLoading(false)
    })
    .catch(val => {
      setIsLoading(false)
      console.log(val)
    })

  }, [couponId, auth.user])

  // const coupons = useSelector(state => state.instructor.coupons);
  const widgetName = useSelector(state => state.instructor.instructor.widgetName)
  const currency = useSelector(state => state.instructor.instructor?.instructorProfile?.currency ?? "USD")
  const currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
  });

  const tableData = redemptions.map(val => {

    // const user = 

    return {
      ...val,
      // user: {
      //   firstName: val?.reservation?.customer_name ?? "",
      //   lastName: "",
      //   platformID: val?.userId
      // },

      discount_amount: currencyFormatter.format(val?.discount_amount)
    }
  })

  const tableColumns = [
      {
        Header: "Name",
        accessor: "user",
        // sort: "desc"
        sortable: true,
        sortMethod: (a,b) => a.firstName > b.firstName ? 1 : -1,
        Cell: row => (
            <UserButton 
                user={row.value}
            />
        ),
      },
      // {
      // Header: "Type",
      // accessor: "discount_type",
      // minWidth: 150
      // },
      {
      Header: "Discount",
      accessor: "discount_amount",
      minWidth: 100,
      filterable: false
      },
      {
      Header: "Date",
      accessor: "timestamp",
      width: 250,
      Cell: row => <span>{moment(row.value * 1000).format('LL')}</span>,
      filterable: false
      },
      // {
      // Header: "Actions",
      // accessor: "actions",
      // sortable: false,
      // width: 100,
      // filterable: false
      // }
  ]

  return (
  <div>
      <ReactTable
        loading={isLoading}
        data={tableData}
        filterable={true}
        columns={tableColumns}
        defaultPageSize={10}
        showPaginationTop={false}
        showPaginationBottom={true}
        className="-highlight"
      />
  </div>
  )
}


function RedemptionsPage(props) {

    const couponId = props.match.params.couponId
    // const dispatch = useDispatch();
    // const partnerId = useSelector(state => state.instructor.instructor.platformID);
    const partner = useSelector(state => state.instructor.instructor);
    const coupon = useSelector(state => state.instructor.coupons.find(val => val.id === couponId));
    // useEffect(() => {
    //     // dispatch
    //     if (partnerId) {
    //     // dispatch(loadOfferings())
    //     // dispatch(loadCoupons())
    //     }
        
    // }, [dispatch, partnerId]);


    const shareLink = "https://sutrapro.com/" + (partner?.widgetName ?? "") + "/gifting"
    return (<>

        <Helmet>
        <title>Coupons</title>
        </Helmet>
        <div className="container px-0 "  >
            <BackButton />
            <section>
                <h1>Code: {coupon?.code}</h1>
                
                <RedemptionsTable
                  {...props}
                  couponId={couponId}
                />
            </section>
        </div>
        </>
    );

}

export default RedemptionsPage;
